import React, { useState, useContext, useEffect } from 'react'
import FieldsView from '@/product/components/organisms/User/FieldsView'
import { dateTimeFormatFunction } from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router-dom'
import * as Yup from 'yup'
import AuthContext from '@/product/context/auth/authContext'

const UserCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const authContext = useContext(AuthContext)
    const { user } = authContext
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        secondaryID: 0,
        user_type: 0,
    })
    const history = useHistory()

    const { user_dynamicfields } = dynamicContext

    const [updatedValues, setUpdatedValues] = useState({})

    const [fieldValue, setFieldValue] = useState([])

    const customInitial = {
        id: 0,
        admin: 1,
    }

    useEffect(() => {
        if (user?.user_id) {
            setManage({
                popup: true,
                status: 'edit',
                id: user?.user_id,
                user_type: 0,
                // secondaryID: props?.match?.params?.sid,
            })
        }
    }, [user?.user_id])

    const customValidation = {
        resale_certificate: Yup.array().when('tax_number', {
            is: (end) => end && end.length > 0,
            then: Yup.array().required('Required!'),
        }),
        ein_no: Yup.string()
            .min(5, 'Minimum 5 characters')
            .max(20, 'Maximum 20 characters')
            .required('Required'),
        phone: Yup.string()
            .trim()
            .min(10, (obj) => {
                if (obj?.value?.length) {
                    return 'Phone must be 10 digits'
                }
            })
            .max(10, (obj) => {
                if (obj?.value?.length) {
                    return 'Phone must be 10 digits'
                }
            })
            .required('Required'),
        additional_phone: Yup.string()
            .trim()
            .nullable()
            .min(10, (obj) => {
                if (obj?.value?.length) {
                    return 'Phone must be 10 digits'
                }
            })
            .max(10, (obj) => {
                if (obj?.value?.length) {
                    return 'Phone must be 10 digits'
                }
            })
            .when('phone', {
                is: (value) => value && value.length === 10,
                then: Yup.string()
                    .nullable()
                    .notOneOf(
                        [Yup.ref('phone')],
                        'Mobile number and additional phone number should not be same'
                    ),
            }),
        phone_type: Yup.string().when('additional_phone', {
            is: (value) => value && value.length === 10,
            then: Yup.string().required('Required!'),
        }),
        license_expiry_date: Yup.date()
            .nullable()
            .min(
                new Date(),
                'Please select a date not earlier than current date'
            )
            .required('Required'),
    }

    useEffect(() => {
        if (user_dynamicfields && user_dynamicfields.length) {
            console.log(user_dynamicfields, 'userr')
            let dynamicValueAssign = []
            user_dynamicfields.map((item) => {
                item.view_on
                    ? item.view_on.includes('4')
                        ? dynamicValueAssign.push(item)
                        : {}
                    : dynamicValueAssign.push(item)
            })
            dynamicValueAssign.push({
                name: 'market_status',
                value: 'draft',
                type: 'default',
                active: 1,
            })
            let temp = dynamicValueAssign.filter((item) => {
                return (
                    item.name != 'password' &&
                    item.name != 'confirm_password' &&
                    item.for_organization === 1
                )
            })
            temp.map((data) => {
                if (data.name == 'phone' || data.name == 'additional_phone') {
                    data.formatPhone =
                        props.formatPhone === false ? false : true
                }
            })
            setFieldValue(temp)
        }
    }, [user_dynamicfields])

    const closeFunction = () => {
        history.goBack()
    }

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }
    return (
        <>
            <Layout>
                <FieldsView
                    fieldValue={fieldValue}
                    customInitial={customInitial}
                    data={manage}
                    function={closeFunction}
                    customValidation={
                        props.customValidation === false
                            ? false
                            : customValidation
                    }
                    formatPhone={props.formatPhone === false ? false : true}
                    changePassword={false}
                    phoneField={
                        props.formatPhone === false
                            ? []
                            : ['phone', 'additional_phone']
                    }
                    additionalFieldUpdate={additionalFieldUpdate}
                    seller={true}
                    standalone={true}
                />
            </Layout>
        </>
    )
}

export default UserCommon
